export const localeToCountry = locale => locale === 'en-NZ' ? 'New Zealand' : 'Australia';